export const forBusiness_furniture_challenges = [
	{
		icon: '💰',
		title: 'challengesData_title1',
		subtitle: 'challengesData_subtitle1',
	},
	{
		icon: '⏳',
		title: 'challengesData_title2',
		subtitle: 'challengesData_subtitle2',
	},
	{
		icon: '💪',
		title: 'challengesData_title3',
		subtitle: 'challengesData_subtitle3',
	},
];

export const challengesAboveList = [
	{
		text: 'challengesData_textAbove_text1',
	},
];
